import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const ImageConverter = () => {
  const [base64, setBase64] = useState('');
  const [copied, setCopied] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(base64);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-800 rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-white">Bild zu Base64 Konverter</h2>
      
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Ihr Profilbild auswählen
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white"
        />
      </div>

      {base64 && (
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-white mb-2">Vorschau:</h3>
            <img
              src={base64}
              alt="Preview"
              className="w-48 h-48 object-cover rounded-lg border border-gray-600"
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-lg font-semibold text-white">Base64 Code:</h3>
              <button
                onClick={copyToClipboard}
                className="flex items-center px-3 py-1 bg-violet-600 hover:bg-violet-700 rounded text-white text-sm"
              >
                {copied ? <Check size={16} /> : <Copy size={16} />}
                {copied ? 'Kopiert!' : 'Kopieren'}
              </button>
            </div>
            <textarea
              value={base64}
              readOnly
              className="w-full h-32 p-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-xs"
            />
          </div>
          
          <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-4">
            <p className="text-green-300 text-sm">
              ✅ Bild erfolgreich konvertiert! Kopieren Sie den Base64-Code und teilen Sie ihn mit mir.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageConverter;